/** Frontmatter for the "week3-waiver-wire-darkness-report" article; the Body lives in week3-waiver-wire-darkness-report.jsx. */
const meta = {
  slug: 'week3-waiver-wire-darkness-report',
  title: 'Week 3 Waiver Wire: The Darkness Report',
  category: 'Waivers',
  author: 'Andy Darkness',
  excerpt: 'Thirty ranked Week 3 pickups led by Denzel Boston and Jonah Coleman, a ten-deep D/ST streaming board, an IDP board, the injury ledger, and the Darkness Doctrine for spending FAAB.',
  readMinutes: 16,
  date: '2026-09-23',
};

export default meta;
